// Constants.
import * as ConfigConstants from 'constants/ConfigConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';


const initialState = {
  isFetching: false,
  isFetched: false,
  config: {},
  errorMessage: '',
};

export default function config(state = initialState, action = {}) {
  switch (action.type) {
    case ConfigConstants.LOAD_CONFIG_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case ConfigConstants.LOAD_CONFIG_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        config: action.config,
      };
    case ConfigConstants.LOAD_CONFIG_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        config: {},
        errorMessage: action.message,
      };
    default:
      return state;
  }
}
